<script setup lang="ts">
import DeviceMeta from '../DeviceMeta';
import { computed } from 'vue';
import type { PropType } from 'vue';
import type { Value } from '../Default/lib';
import type { MetaProps } from '../DeviceMeta/lib';

const props = defineProps({
  // A level value is expected in the range of 0 to 100
  level: {
    type: Object as PropType<Value>,
    default: undefined,
  },
  meta: {
    type: Object as PropType<MetaProps>,
    required: true,
  },
});

const height = computed(() => props.level
  ? props.level.value
  : 0);
const animationHeight = computed(() => `${Math.max(0, height.value - 20)}%`);
</script>

<template>
  <div class="w-full text-white font-light font-sans relative">
    <div class="flex flex-row justify-center space-x-4 text-2xl">
      <div
        class="h-[170px] flex customBorder border-solid border-t-0 z-9999 border-b-0 border-gray-500  relative cylinder"
      >
        <div class="absolute top-0 h-12 w-full border-1 border-solid border-gray-600 rounded-full top-circle bg-black" />
        <div
          :style="`height: ${height}%;`"
          class="self-end mb-4  w-[100%] bg-cyan-900 border-0 z-999 border-solid border-gray-900 border-t-0 max-h-[93%] animation-1"
        />
        <div
          class="absolute bottom-1  bg-black-200 h-36 w-[100%] z-0 border-0 border-solid bg-cyan-900 border-gray-500 rounded-full bottom-circle"
        />
      </div>
      <div
        v-if="props.level"
        class="self-center w-fit"
      >
        {{ props.level.value }}{{ props.level.unit }}
      </div>
    </div>

    <DeviceMeta
      v-if="props.meta"
      v-bind="props.meta"
    />
  </div>
</template>

<style scoped>
.cylinder {
  width: 130px;
  z-index: 999;
}

.top-circle {
  transform: rotateX(76deg);
  width: 144% !important;
  height: 192px !important;
  margin-top: -97px;
  margin-left: -28px;
  scale: 0.7;
  z-index: 9999 !important;
}

.bottom-circle {
  transform: rotateX(73deg);
  width: 101% !important;
  height: 180px !important;
  margin-bottom: -85px;
}

.level {
  transform: rotateX(0deg);
  z-index: 999;
}

.levelNotDefault {
  transform: rotateX(0deg);
  padding-top: 20px;
  border-top-left-radius: 0% !important;
  border-top-right-radius: 0% !important;
  z-index: 999;
}

@keyframes bg-pulse {
  from {
    height: 0;
    background-color: rgb(14, 68, 85);
  }

  to {
    height: var(--target-height);
  }
}

.animation-1 {
  animation: bg-pulse ease-in 0.3s;
  animation-duration: 1.2s;

}

.customBorder {
  border-right: 0.3px solid rgba(211, 211, 211, 0.303);
  border-left: 0.3px solid rgba(211, 211, 211, 0.303);
}
</style>
